export default "__VITE_ASSET__Czlq0GbU__"